import CityPageTemplate from "../city-template/CityPageTemplate";
import { rockfordConfig } from "./data";

export default function RockfordPage() {
  return <CityPageTemplate config={rockfordConfig} />;
}